import { CUST_STATUS_PILL, PROJ_STATUS_PILL } from "../constants/projectsViewV2Constants";

export function custStatusPill(status) {
  return CUST_STATUS_PILL[status] || "pjv2-pill--inactive";
}

export function projStatusPill(status) {
  return PROJ_STATUS_PILL[status] || "pjv2-pill--inactive";
}

export function filterCustomers(rows, q) {
  if (!q) return rows;
  const lq = q.toLowerCase();
  return rows.filter(r =>
    r.customer_name?.toLowerCase().includes(lq) ||
    r.customer_code?.toLowerCase().includes(lq) ||
    r.account_manager_name?.toLowerCase().includes(lq)
  );
}

export function filterProjects(rows, q) {
  if (!q) return rows;
  const lq = q.toLowerCase();
  return rows.filter(r =>
    r.project_name?.toLowerCase().includes(lq) ||
    r.customer_name?.toLowerCase().includes(lq) ||
    r.project_code?.toLowerCase().includes(lq) ||
    r.account_manager_name?.toLowerCase().includes(lq)
  );
}

// ── Filter defaults ──────────────────────────────────────────────────────────

export const DEFAULT_CUSTOMER_FILTERS = {
  status: { op: "is_not", values: ["Inactive"] },
};

export const DEFAULT_PROJECT_FILTERS = {
  status: { op: "is_not", values: ["Inactive", "Closed"] },
};

// ── Filter field definitions (options built dynamically from live data) ──────

export function buildCustFilterFields(customers) {
  const managers = unique(customers.map(c => c.account_manager_name).filter(Boolean));
  return [
    {
      key: "status",
      label: "Status",
      options: ["Active", "Inactive", "Prospect"].map(s => ({ value: s, label: s })),
    },
    {
      key: "account_manager_name",
      label: "Account Manager",
      options: managers.map(n => ({ value: n, label: n })),
    },
  ];
}

export function buildProjFilterFields(projects, customers) {
  const statuses  = unique(projects.map(p => p.status).filter(Boolean));
  const custNames = unique(customers.map(c => c.customer_name).filter(Boolean));
  const managers  = unique(projects.map(p => p.account_manager_name).filter(Boolean));
  return [
    {
      key: "status",
      label: "Status",
      options: (statuses.length ? statuses : ["Active", "Inactive", "Closed"]).map(s => ({ value: s, label: s })),
    },
    {
      key: "customer_name",
      label: "Customer",
      options: custNames.map(n => ({ value: n, label: n })),
    },
    {
      key: "account_manager_name",
      label: "Account Manager",
      options: managers.map(n => ({ value: n, label: n })),
    },
  ];
}

// ── Apply advanced filters ───────────────────────────────────────────────────

function applyFilters(rows, appliedFilters, filterMode, getField) {
  const entries = Object.entries(appliedFilters || {}).filter(([, v]) => v?.values?.length > 0);
  if (entries.length === 0) return rows;
  return rows.filter(row => {
    const checks = entries.map(([key, filter]) => {
      const cell   = String(getField(row, key) || "");
      const values = filter.values.map(String);
      const hit    = values.some(v => v.toLowerCase() === cell.toLowerCase());
      return filter.op === "is_not" ? !hit : hit;
    });
    return filterMode === "any" ? checks.some(Boolean) : checks.every(Boolean);
  });
}

export function applyCustomerFilters(rows, appliedFilters, filterMode) {
  return applyFilters(rows, appliedFilters, filterMode,
    (row, key) => row[key] ?? "");
}

export function applyProjectFilters(rows, appliedFilters, filterMode) {
  return applyFilters(rows, appliedFilters, filterMode,
    (row, key) => row[key] ?? "");
}

export function countActiveFilters(appliedFilters) {
  return Object.values(appliedFilters || {}).filter(v => v?.values?.length > 0).length;
}

// ── Helpers ──────────────────────────────────────────────────────────────────

function unique(arr) {
  return [...new Set(arr)].sort((a, b) => a.localeCompare(b));
}
